import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-order-grant-pte-dialog',
  templateUrl: './work-order-grant-pte-dialog.component.html',
  styleUrls: ['./work-order-grant-pte-dialog.component.css']
})
export class WorkOrderGrantPteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
